import { LABEL_URL } from "../../services/common-urls";
import { MHTTPCL } from "../../services/http/http-client";

export const DBoxSalesService = {
  filterSales: ({
    section = 'products',
    action = 'filter_product_sales',
    product_id='',
    track_id='',
    transaction_type = '',
    account_id = '',
    country_id = '',
    period = '',
    usage_type=''
  }) => MHTTPCL.post(LABEL_URL, {
    section,
    action,
    product_id,
    track_id,
    transaction_type,
    account_id,
    country_id,
    period,
    usage_type
  }),
  exportSales: ({
    product_id,
    transaction_type = '',
    account_id = '',
    country_id = '',
    period = '',
    transaction_type_txt = '',
    account = '',
    country = '',
    period_txt = '',
  } = {}) => MHTTPCL.getFinalURL(LABEL_URL, {
    section: 'products',
    action: 'export_product_sales',
    product_id,
    transaction_type,
    account_id,
    country_id,
    period,
    transaction_type_txt,
    account,
    country,
    period_txt,
  })
}